import {
  Component,
  OnInit,
  input,
  inject,
  signal,
  linkedSignal,
  computed,
  effect
} from '@angular/core';
import { CommonModule } from '@angular/common';
import LayerGroup from 'ol/layer/Group';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { Layer } from 'ol/layer';
import BaseLayer from 'ol/layer/Base';
import { AccordionComponent, AccordionItemComponent, RadioGroupComponent, RadioItemComponent } from '@aetherion/ui';
@Component({
  selector: 'app-base-group',
  templateUrl: './base-group.component.html',
  styleUrls: ['./base-group.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    AccordionComponent,
    AccordionItemComponent,
    RadioGroupComponent,
    RadioItemComponent,
    FormsModule
  ]
})
export class BaseGroupComponent implements OnInit {
  readonly layerGroup = input.required<LayerGroup>();

  readonly layers = computed(() => this.layerGroup().getLayersArray());

  layerMetaData = computed(() => {
    const layers = this.layers();

    return layers.map((lyr) => ({
      title: lyr.get('title'),
      lyr
    }));
  });

  selectedBaseMap = linkedSignal(() => {
    const layerMetaData = this.layerMetaData();
    return layerMetaData.find((meta) => meta.lyr.getVisible()) ?? null;
  });

  title = computed(() =>
    this.layerGroup() == null ? 'Unknown' : this.layerGroup().get('title')
  );

  ngOnInit(): void {}
  constructor() {
    effect(() => {
      const selectedBaseMap = this.selectedBaseMap();
      const layerMetaData = this.layerMetaData();

      if (layerMetaData.length === 0) {
        return;
      }

      layerMetaData.forEach((meta) => {
        const shouldShow =
          selectedBaseMap && meta.title === selectedBaseMap.title;
        meta.lyr.setVisible(shouldShow);
      });
    });
  }
}
